import { render, staticRenderFns } from "./CustomerLimit.vue?vue&type=template&id=4a37c3b6"
import script from "./CustomerLimit.vue?vue&type=script&lang=js"
export * from "./CustomerLimit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports